module.exports = __webpack_public_path__ + "static/state-transitions-@2x-3b2a41b410ae58f1fd74c1b77d6fdc05.jpg";